import React from 'react'
import styles from './styles.module.css'
import { getScoreRange } from '../Score/utils'
import cn from 'classnames'
import { Text } from 'src/comps/Atom/Text'
import { Bar } from 'src/comps/Atom/Bar'

interface IRatingSubRatingsProps {
  subScores: Array<{
    name: string
    localizedName: string
    value: number
  }>
}

const RatingSubRatings = ({ subScores }: IRatingSubRatingsProps) => {
  if (!subScores) {
    return null
  }

  return (
    <>
      {subScores.length > 0 && (
        <ul className={cn(styles.subRatingsWrap)} data-testid="subratings">
          {subScores.map(subScore => (
            <li className={styles.subRating} key={subScore.name} data-testid={subScore.name}>
              <Text as="p" variant="captionL">
                {subScore.localizedName}
              </Text>
              <Bar
                color={getScoreRange(subScore.value).color}
                value={subScore.value * 10}
                className={styles.bar}
              />
              <div className={styles.subScore}>{subScore.value.toFixed(1)}</div>
            </li>
          ))}
        </ul>
      )}
    </>
  )
}

export default RatingSubRatings
